import {
    GET_CARGAS_PREVIAS_ACT,
    POST_CARGAR_ARCHIVO_ACT,
    GET_INGRESO_PAGOS_ACT,
    GET_COMBO_TIPO_MOVIMIENTO

} from '../types';


export default function cargaArchivoActualizacionCIAReducer(state = {}, action) {
    switch (action.type) {
        case GET_CARGAS_PREVIAS_ACT:
            return { ...state, ...action.payload }
        case POST_CARGAR_ARCHIVO_ACT:
            return { ...state, archivo: action.payload }
        case GET_INGRESO_PAGOS_ACT:
            return { ...state, ingresoPagos: action.payload }
        case GET_COMBO_TIPO_MOVIMIENTO:
                return { ...state, comboTipoMovimiento: action.payload }
        default:
            return state
    }
}